import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, size } from '../../theme/tokens';

export const StyledTextArea = styled.textarea`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${layout.inputPadding};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-sm']};
  color: ${semantic.text.primary};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 80px;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:focus {
    border-color: ${colors.primary};
  }

  &[aria-invalid='true'] {
    border-color: ${semantic.border.danger};
  }
`;
